// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listStyles } from "@rpsc/Overrides/Widgets/Brand/BrandGallery";
import IconArrowRightLink from "@rpsc/XDL/Icons/IconArrowRightLink";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

listStyles.titleText = {
    variant: "h2",
    size: 24,
    weight: fontConfig.weight.bold,
    css: css`
        line-height: 32px;
        margin-bottom: 4px;
    `,
};

listStyles.link = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
        padding: 12px 11px;
        ${xScreen("lte", "md")} {
            padding: 12px 10px;
        }
        ${xScreen("lte", "xs")} {
            padding: 12px 8px;
        }
    `,
};

listStyles.carouselLink = {
    css: css`
        display: flex;
        padding: 12px 0;
    `,
};

listStyles.image = {
    height: "102px",
    width: "100%",
    css: css`
        ${({ maximumBrandImageHeight }: any) =>
            maximumBrandImageHeight
                ? css`
                      height: ${maximumBrandImageHeight}px;
                  `
                : css`
                      height: 102px;
                  `};
        width: 204px;
        ${xScreen("lte", "md")} {
            height: 116px;
            width: 232px;
        }
        ${xScreen("lte", "xs")} {
            height: 78px;
            width: 156px;
        }
        img {
            object-fit: contain;
        }
    `,
};

listStyles.carouselImage = {
    width: "204px",
    height: "100%",
    css: css`
        ${({ maximumBrandImageHeight }: any) =>
            maximumBrandImageHeight
                ? css`
                      height: ${maximumBrandImageHeight}px;
                  `
                : css`
                      height: 102px;
                  `};

        img {
            max-height: 100%;
            object-fit: contain;
        }
        ${xScreen("lte", "md")} {
            height: 116px;
            width: 232px;
        }
        ${xScreen("lte", "xs")} {
            height: 78px;
            width: 156px;
        }
    `,
};

listStyles.imageItem = {
    css: css`
        padding: 0;
    `,
};

listStyles.brandName = {
    size: 16,
    weight: fontConfig.weight.bold,
    color: "common.black",
    css: css`
        line-height: 22px;
        max-width: 204px;
        text-align: center;
        ${xScreen("lte", "md")} {
            max-width: 232px;
        }
        ${xScreen("lte", "xs")} {
            max-width: 156px;
        }
        &:hover {
            color: ${color("common.ui8")};
        }
    `,
};

listStyles.titleWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        ${xScreen("lte", "xs")} {
            flex-direction: column;
            align-items: flex-start;
            gap: 12px;
        }
    `,
};

listStyles.imageContainer = {
    css: css`
        justify-content: flex-start;
    `,
};
